import React from 'react'

import { COLORS } from '../../theme'

interface Props {
  countryCode: string | null
  width?: number
  height?: number
}

const CountryFlag = ({ width = 20, height = 15, countryCode }: Props): JSX.Element => {
  if (typeof countryCode !== 'string') {
    return <></>
  }
  return (
    <img
      style={{ width, height, borderRadius: 3, borderWidth: 1, borderColor: COLORS.grey }}
      src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode.toUpperCase()}.svg`}
    />
  )
}

export default CountryFlag
